import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ApolloLink } from '@apollo/client';
import { isWindowDefined, getCookie, CookieName } from '@chegg/utils';
export var isExternalDomain = function isExternalDomain(hostname) {
  return !(hostname.includes('.chegg.com') || hostname.includes('.cheggnet.com'));
};
export var createAuthLink = function createAuthLink() {
  return new ApolloLink(function (operation, forward) {
    var context = operation.getContext();
    var headers = _objectSpread({}, context.headers);
    if (isWindowDefined) {
      headers['x-chegg-page-url'] = window.location.href;
      if (isExternalDomain(window.location.hostname)) {
        var idToken = getCookie(CookieName.ID_TOKEN);
        var accessToken = getCookie(CookieName.ACCESS_TOKEN);
        if (idToken) headers.id_token = idToken;
        if (accessToken) headers.access_token = accessToken;
        operation.setContext({
          headers: headers,
          credentials: 'omit'
        });
      } else {
        operation.setContext({
          headers: headers
        });
      }
    }
    return forward(operation);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/links/authLink.js
// module id = 1428
// module chunks = 11